import {
  styled,
  TextField,
  IconButton,
  Paper,
  Card,
  CardActionArea,
  CardContent,
  Typography,
  Box,
  Tab,
  useMediaQuery,
  Modal,
  Button,
  Dialog,
  DialogContent,
  DialogActions,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import "./document_details.css";
import { useLocation, useNavigate } from "react-router-dom";
import Grid from "@mui/material/Grid2";
import SearchIcon from "@mui/icons-material/Search";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import Event1 from "../../../images/event1.jpg";
import Doc1 from "../../../upload/test.pdf";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { Form } from "antd";
import getEventController from "../Controller/getEvent_controller";
import SearchBar from "../../../components/SearchBox/searchbox";
import PPKMLogo from "../../../images/ppkmLogo.jpg";

import * as pdfjsLib from "pdfjs-dist";
// import pdfWorker from "pdfjs-dist/build/pdf.worker.mjs";

pdfjsLib.GlobalWorkerOptions.workerSrc = new URL(
  "pdfjs-dist/build/pdf.worker.min.mjs",
  import.meta.url
).toString();

// Function to generate PDF thumbnails
const getPdfThumbnail = async (pdfUrl) => {
  const pdf = await pdfjsLib.getDocument(pdfUrl).promise;
  const page = await pdf.getPage(1);
  const scale = 1.5; // Adjust for better resolution
  const viewport = page.getViewport({ scale });

  const canvas = document.createElement("canvas");
  const context = canvas.getContext("2d");
  canvas.width = viewport.width;
  canvas.height = viewport.height;

  await page.render({ canvasContext: context, viewport }).promise;

  return canvas.toDataURL("image/png"); // Convert canvas to image URL
};

// Function to return a file icon for non-PDF files
const getFileIcon = (fileUrl) => {
  if (fileUrl.endsWith(".doc") || fileUrl.endsWith(".docx")) {
    return "https://upload.wikimedia.org/wikipedia/commons/8/87/Microsoft_Word_2013_logo.svg"; // Word icon
  }
  if (fileUrl.endsWith(".xls") || fileUrl.endsWith(".xlsx")) {
    return "https://upload.wikimedia.org/wikipedia/commons/8/86/Microsoft_Excel_2013_logo.svg"; // Excel icon
  }
  return "https://upload.wikimedia.org/wikipedia/commons/8/87/PDF_file_icon.svg"; // Default PDF icon
};

const DocumentDetails = () => {
  const navigate = useNavigate(); // Initialize useNavigate hook
  const location = useLocation();
  const isLargeScreen = useMediaQuery("(min-width:640px)");
  const [spacing, setSpacing] = React.useState(2);
  const membertypeID = localStorage.getItem("member_type");
  const committeetypeID = localStorage.getItem("committee_type");
  const memberId = localStorage.getItem("memberId");
  const { documentCategoryID, title } = location.state;

  const [form] = Form.useForm();
  const [documentListData, setdocumentListData] = useState([]);
  const [filtereddocumentListData, setFiltereddocumentListData] = useState([]);

  // State for managing modal
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [open, setOpen] = useState(false);

  // Sample events array with image and title data
  const documents = [];

  useEffect(() => {
    getEventController
      .getViewableDocuments(documentCategoryID, membertypeID, committeetypeID)
      .then((response) => {
        console.log("API Response:", response); // Debugging log

        if (Array.isArray(response)) {
          // Ensure response is an array
          setdocumentListData(response);
        } else {
          console.error("API response is not an array:", response);
          setdocumentListData([]); // Set empty array to prevent .map() errors
        }
      })
      .catch((error) => {
        console.error("Error fetching event categories:", error);
        setdocumentListData([]); // Handle errors gracefully
      });
  }, []);

  const handleSearch = (searchTerm) => {
    if (!searchTerm) {
      setFiltereddocumentListData(documentListData);
    } else {
      const lowercasedTerm = searchTerm.toLowerCase();

      setFiltereddocumentListData(
        documentListData.filter((event) => {
          const label = event.label?.toLowerCase() ?? "";
          const datetime = event.datetime_created ?? "";
          const year = datetime.substring(0, 4); // or use: new Date(datetime).getFullYear().toString()
          const author = event.author_name?.toLowerCase() ?? "";

          return (
            label.includes(lowercasedTerm) ||
            datetime.toLowerCase().includes(lowercasedTerm) ||
            year.includes(lowercasedTerm) ||
            author.includes(lowercasedTerm)
          );
        })
      );
    }
  };

  useEffect(() => {
    setFiltereddocumentListData(documentListData);
  }, [documentListData]);

  //   const [thumbnails, setThumbnails] = useState({});

  //   useEffect(() => {
  //     const generateThumbnails = async () => {
  //       const thumbData = {};

  //       for (const event of documentListData) {
  //         if (event.file_url.endsWith(".pdf")) {
  //           thumbData[event.file_url] = await getPdfThumbnail(event.file_url);
  //         } else {
  //           // Set a generic icon for non-PDF files
  //           thumbData[event.file_url] = getFileIcon(event.file_url);
  //         }
  //       }

  //       setThumbnails(thumbData);
  //     };

  //     generateThumbnails();
  //   }, [documentListData]);

  const handleEventClick = (file_url) => {
    // Open the file URL in a new tab
    window.open(file_url, "_blank");
  };

  // Handle click to open modal and set the selected document
  const handleOpen = (doc) => {
    setSelectedDocument(doc);
    setOpen(true);
  };

  // Handle close modal
  const handleClose = () => {
    setOpen(false);
    setSelectedDocument(null);
  };

  // Handle download function
  const handleDownload = () => {
    if (selectedDocument) {
      const link = document.createElement("a");
      link.href = selectedDocument.Doc1;
      link.download = selectedDocument.title; // sets download filename
      link.click();
    }
  };

  const dc000005GroupedByYear = filtereddocumentListData
    .filter((event) => event.document_categoryID === "DC-000005")
    .reduce((acc, curr) => {
      const year = new Date(curr.datetime_created).getFullYear(); // Extract year
      if (!acc[year]) acc[year] = [];
      acc[year].push(curr);
      return acc;
    }, {});

  return (
    <React.Fragment>
      {!isLargeScreen ? (
        <div className="gallery-list">
          {/*Search Bar */}
          <div className="row-1 ">
            <Grid className="sec_grid" container spacing={2}>
              <Grid size={12}>
                <TextField
                  className="searchbar"
                  label="Search"
                  variant="outlined"
                  size="small"
                  slotProps={{
                    input: {
                      endAdornment: (
                        <IconButton
                          type="button"
                          aria-label="search"
                          size="small"
                        >
                          <SearchIcon />
                        </IconButton>
                      ),
                    },
                  }}
                />
              </Grid>
            </Grid>
          </div>
          {/*Documents Grid*/}
          <div className="document-row">
            <Grid container spacing={2} sx={{ justifyContent: "center" }}>
              {documents.map((doc, index) => (
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={4}
                  lg={3}
                  key={index}
                  sx={{ display: "flex", justifyContent: "center" }}
                >
                  <Paper
                    sx={(theme) => ({
                      display: "flex",
                      height: 300,
                      width: 250,
                      marginTop: "20px",
                      backgroundColor: "#fff",
                      ...theme.applyStyles("dark", {
                        backgroundColor: "#1A2027",
                      }),
                      boxShadow: 5,
                      justifyContent: "center",
                      alignItems: "center",
                    })}
                    onClick={() => handleOpen(doc)}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        fontSize: "12px",
                        textAlign: "center",
                        fontWeight: "bold",
                      }}
                    >
                      <img
                        src={doc.imgSrc}
                        alt={doc.title}
                        className="upcoming-event-icon"
                      />
                      <span>{doc.title}</span>
                    </div>
                  </Paper>
                </Grid>
              ))}
            </Grid>
          </div>
        </div>
      ) : (
        <div className="gallery-list">
          <div className="gallery-title">{title}</div>
          {/*Search Bar */}
          <SearchBar onSearch={handleSearch} />
          {/*Documents Grid*/}
          {documentCategoryID === "DC-000005" ? (
            <div className="document-row">
              {Object.keys(dc000005GroupedByYear)
                .sort((a, b) => b - a) // sort years descending
                .map((year) => (
                  <div
                    key={year}
                    style={{
                      marginBottom: "40px",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center", // ✅ Center everything inside
                    }}
                  >
                    {/* Year Header */}
                    <h2
                      style={{
                        fontSize: "24px",
                        color: "#b24743",
                        borderBottom: "2px solid #b24743",
                        marginBottom: "15px",
                        textAlign: "center",
                        maxWidth: "70%", // ✅ limit label width
                        width: "100%",
                        fontWeight: "bold",
                      }}
                    >
                      Year {year}
                    </h2>

                    {/* One Row for this Year */}
                    <div
                      style={{
                        display: "flex",
                        flexWrap: "nowrap", // no wrap, force one row
                        // overflowX: "auto", // make it scrollable horizontally
                        gap: "20px",
                        paddingBottom: "10px",
                      }}
                    >
                      {dc000005GroupedByYear[year].map((doc, index) => (
                        <div
                          key={index}
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            minWidth: "230px", // prevent wrap on small screens
                          }}
                        >
                          <Paper
                            onClick={() => handleEventClick(doc.file_url)}
                            sx={{
                              height: "auto",
                              width: "230px",
                              backgroundColor: "#fff",
                              overflow: "hidden",
                              cursor: "pointer",
                              transition: "0.3s",
                              "&:hover": {
                                transform: "scale(1.03)",
                                boxShadow: 5,
                              },
                            }}
                          >
                            <img
                              src={
                                doc.poster_url?.trim()
                                  ? doc.poster_url
                                  : "fallback-image-url"
                              }
                              alt={doc.label}
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                              }}
                            />
                          </Paper>
                          <div
                            style={{
                              marginTop: "10px",
                              fontWeight: "bold",
                              fontSize: "16px",
                              textAlign: "center",
                            }}
                          >
                            {doc.label}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
            </div>
          ) : documentCategoryID === "DC-000004" ? (
            <div className="document-row">
              <Grid container spacing={2} sx={{ justifyContent: "center" }}>
                {filtereddocumentListData.map((event, index) => {
                  const formattedDate = new Date(
                    event.datetime_created
                  ).toLocaleDateString("en-US", {
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                  });

                  return (
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      md={4}
                      lg={3}
                      key={index}
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      <Paper
                        sx={(theme) => ({
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                          height: "200px",
                          width: "450px",
                          marginTop: "20px",
                          backgroundColor: "#fff",
                          ...theme.applyStyles("dark", {
                            backgroundColor: "#1A2027",
                          }),
                          boxShadow: 5,
                          border: "2px solid #b24743",
                          borderRadius: "15px",
                          cursor: "pointer",
                          transition: "transform 0.3s ease-in-out",
                          "&:hover": {
                            transform: "scale(1.03)",
                            boxShadow: 10,
                          },
                        })}
                        onClick={() => handleEventClick(event.file_url)}
                      >
                        {/* Author Image */}
                        <div
                          style={{
                            flex: "0 0 150px",
                            height: "auto",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            padding: "10px",
                          }}
                        >
                          <img
                            src={event.author_image_url || PPKMLogo}
                            alt="Author"
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                              borderRadius: "10px",
                            }}
                          />
                        </div>

                        {/* Text Content */}
                        <div
                          style={{
                            flex: 1,
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            padding: "10px 15px",
                          }}
                          id={event.id}
                        >
                          <div
                            style={{
                              fontWeight: "bold",
                              fontSize: "18px",
                              marginBottom: "8px",
                            }}
                          >
                            {event.label}
                          </div>
                          <div
                            style={{
                              fontSize: "14px",
                              marginBottom: "5px",
                            }}
                          >
                            by {event.author_name}
                          </div>
                          <div
                            style={{
                              fontSize: "13px",
                              color: "gray",
                            }}
                          >
                            {formattedDate}
                          </div>
                        </div>
                      </Paper>
                    </Grid>
                  );
                })}
              </Grid>
            </div>
          ) : (
            <div className="document-row">
              <Grid container spacing={2} sx={{ justifyContent: "center" }}>
                {filtereddocumentListData.map((event, index) => (
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={4}
                    lg={3}
                    key={index}
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <Paper
                      sx={(theme) => ({
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        height: "250px",
                        width: "450px",
                        marginTop: "20px",
                        backgroundColor: "#fff",
                        ...theme.applyStyles("dark", {
                          backgroundColor: "#1A2027",
                        }),
                        boxShadow: 5,
                        justifyContent: "center",
                        border: "2px solid #b24743",
                        borderRadius: "15px",
                        cursor: "pointer",
                        transition: "transform 0.3s ease-in-out",
                        "&:hover": {
                          transform: "scale(1.03)",
                          boxShadow: 10,
                        },
                      })}
                      onClick={() => handleEventClick(event.file_url)}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          padding: "10px",
                          textAlign: "center",
                          height: "100px",
                        }}
                        id={event.id}
                      >
                        <span className="document-title">{event.label}</span>
                      </div>
                      <div
                        style={{
                          width: "100%",
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <button
                          style={{
                            width: "80%",
                            padding: "10px",
                            backgroundColor: "#b24743",
                            color: "white",
                            border: "none",
                            borderRadius: "5px",
                            cursor: "pointer",
                            fontSize: "16px",
                            fontWeight: "bold",
                            transition: "background-color 0.3s",
                          }}
                        >
                          View Document
                        </button>
                      </div>
                    </Paper>
                  </Grid>
                ))}
              </Grid>
            </div>
          )}
        </div>
      )}

      {/* Dialog to show the PDF preview */}
      <Dialog open={open} onClose={handleClose} maxWidth="lg" fullWidth>
        <DialogContent>
          {selectedDocument ? (
            <iframe
              src={selectedDocument}
              title="PDF Preview"
              width="100%"
              height="600px"
              style={{ border: "none" }}
            ></iframe>
          ) : (
            <p>Loading...</p>
          )}
        </DialogContent>
        <DialogActions>
          {/* Download Button */}
          <Button
            component="a"
            href={selectedDocument}
            download
            target="_blank"
            rel="noopener noreferrer"
            // color="primary"
            variant="contained"
            sx={{
              background: "#d33333",
            }}
          >
            Download
          </Button>
          <Button onClick={handleClose}>Close</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};

export default DocumentDetails;
